module.exports = __webpack_public_path__ + "img/check-document.1257a42.svg";